export var toIntegerFromBool = function (value) { return value ? 1 : 0; };
//# sourceMappingURL=toIntegerFromBool.js.map